module.exports = __webpack_public_path__ + "static/media/UdemyCSS.84e37d2e.jpg";